<template>
  <div class="p-the-c01-item-info">
    <TextLabel
      v-if="status"
      :color="{ border: colorCode, content: '#fff' }"
      :reverse="true"
      class="p-the-c01-item-info__status"
      >{{ status }}</TextLabel
    >
    <p class="p-the-c01-item-info__name">{{ name }}</p>
    <p class="p-the-c01-item-info__id">商品NO.{{ id }}</p>
    <div class="p-the-c01-item-info__point">
      <PointNotation
        :point="point"
        :point-color="colorCode"
        :sign-is-exists="false"
      />
      <!-- <span class="p-the-c01-item-info__point__discount_rate"
        >({{ discountRate }}%OFF)</span
      >-->
    </div>
    <div
      v-if="isQuantityControl && !isBenepoExchange"
      class="p-the-c01-item-info__stock"
    >
      在庫数 : {{ stockText }}
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    id: { type: [String, Number], required: true, default: "" },
    name: { type: String, required: true, default: "" },
    point: { type: Number, required: false, default: 0 },
    stock: { type: Number, required: false, default: 0 },
    discountRate: { type: Number, required: false, default: 0 },
    status: { type: [String, Boolean], required: false, default: "" },
    isQuantityControl: { type: Boolean, required: true },
    isBenepoExchange: { type: Boolean, required: true, default: false }
  },
  components: {
    TextLabel,
    PointNotation
  }
})
export default class TheC01ItemInfo extends Vue {
  id!: string | number;
  name!: string;
  point!: number;
  stock!: number;
  discountRate!: number;
  status!: string | boolean;
  isQuantityControl!: boolean;
  isBenepoExchange!: boolean;

  get unit() {
    return commons.unit;
  }
  get colorCode() {
    return this.stock > 0 ? commons.colorCode : "#333";
  }

  get stockText() {
    return this.stock > 0 ? this.stock : "現在在庫切れです";
  }
}
</script>

<style lang="scss" scoped>
.p-the-c01-item-info {
  &__name {
    @include text__body--l;
    margin-top: rem(16);
  }

  &__id {
    @include text__body--s;
    color: $common-black-sub;
    margin-top: rem(8);
  }

  &__point {
    margin-top: rem(24);
    display: flex;
    align-items: center;

    @include sp {
      margin-top: rem(16);
    }

    &__discount_rate {
      margin-left: rem(16);
      color: $common-primary;
      @include text__body--s;
    }
  }

  &__stock {
    @include text__body--s;
    padding: rem(16);
    background-color: $common-bg;
    margin-top: rem(32);
    width: rem(288);
  }
}
</style>
